import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield, CheckCircle, Star, TrendingUp } from 'lucide-react';

const WhyNeedSection = ({ onOpenContactForm }) => {
  const reasons = [
    { icon: Shield, title: 'Nationwide Legal Rights', desc: 'Exclusive federal protection across all 50 states' },
    { icon: CheckCircle, title: 'Brand Credibility', desc: 'Use the official \u00AE registered symbol' },
    { icon: Star, title: 'Amazon Brand Registry', desc: 'Required for Brand Registry enrollment' },
    { icon: TrendingUp, title: 'Increase Business Value', desc: 'Trademark is a valuable business asset' },
  ];

  return (
    <section className="py-24 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #1A0A0E 0%, #2A1118 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold-400 mb-4">Why It Matters</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight leading-tight mb-4">
            <span className="text-white">Federal Protection Is</span><br/>
            <span className="text-gold-400">Essential for Every Business</span>
          </h2>
          <p className="text-wine-300 leading-relaxed">
            US trademark registration gives your brand exclusive rights nationwide. For Amazon sellers, it's mandatory for Brand Registry enrollment.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          {reasons.map((item, i) => (
            <div key={i} className="bg-wine-900/50 rounded-xl p-6 border border-wine-700/30 hover:border-gold-400/40 hover:bg-wine-800/50 transition-all duration-300 group">
              <div className="w-10 h-10 bg-wine-800 rounded-lg flex items-center justify-center mb-3 group-hover:bg-gold-500 border border-wine-700/50 transition-all">
                <item.icon className="w-5 h-5 text-gold-400 group-hover:text-wine-950" strokeWidth={1.5} />
              </div>
              <h4 className="text-white font-semibold mb-1">{item.title}</h4>
              <p className="text-wine-400 text-sm">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button data-testid="why-trademark-cta" onClick={onOpenContactForm} className="bg-gold-500 hover:bg-gold-400 text-wine-950 font-semibold px-6 shadow-lg shadow-gold-500/20 transition-all">
            Protect Your Brand <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default WhyNeedSection;
